export default __webpack_public_path__ + "static/media/Google-Button.4beeae57.svg";